import { render } from "./ContractInvitation.vue?vue&type=template&id=64abf7b6"
import script from "./ContractInvitation.vue?vue&type=script&lang=js"
export * from "./ContractInvitation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__